import {
    getWishListsDataView,
    getWishListState,
} from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useWishListState = convertSelectorToHook(getWishListState);
export const useWishListDataView = convertSelectorToHook(getWishListsDataView);
